import { useEffect } from 'react';

import { InfiniteData, useInfiniteQuery } from '@tanstack/react-query';
import { ITrainingSetListResponse } from '../../api/types';
import { ITrainingSet } from '../../types/my-types';
import useGlynt from './useGlynt';

import { TRAINING_SET_PAGINATION } from '../../constants';

import { getOffsetFromUrl } from '../../utils/getOffsetFromUrl';

function mergeResults(data: InfiniteData<ITrainingSetListResponse> | undefined) {
  if (!data) return [];

  let results: ITrainingSet[] = [];

  data.pages.map((page) => {
    results = results.concat(page.results);
    return true;
  });

  return results;
}

// get all training sets from datapool
export default function usePublicTrainingSets(dataPoolId: string, search?: string) {
  const glynt = useGlynt();

  const { data, isError, isLoading, isFetching, fetchNextPage, hasNextPage, refetch } =
    useInfiniteQuery({
      queryKey: ['publicTrainingSets', { dataPoolId, ...(search ? { search } : {}) }],
      queryFn: async ({ pageParam }) =>
        (await glynt).trainingSet.listPublic(dataPoolId, {
          advanced: true,
          ordering: 'label',
          offset: pageParam,
          limit: TRAINING_SET_PAGINATION,

          // optional params:
          ...(search && { ilabel__contains: search }),
        }),
      initialPageParam: 0,
      getNextPageParam: (lastPage) => {
        if (lastPage.next) return getOffsetFromUrl(lastPage.next);
      },
      refetchOnWindowFocus: false,
      enabled: !!dataPoolId,
    });

  useEffect(() => {
    if (hasNextPage) {
      fetchNextPage();
    }
  }, [data, hasNextPage, fetchNextPage]);

  if (isLoading || isFetching || isError) {
    return [];
  }

  return mergeResults(data);
}
